import { SliderImagesResponse } from "@/types/image";

const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_URL || "https://www.lilylanka.com";

export const imageService = {
  async getSliderImages(): Promise<SliderImagesResponse> {
    const response = await fetch(`${API_BASE_URL}/api/Image/by-type/1001`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch slider images: ${response.statusText}`);
    }

    return response.json();
  },
};
